(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1845);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ IndexMedia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_media_media_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4236);
/* harmony import */ var _styles_components_media_media_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_media_media_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2298);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3855);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);





const IndexMedia = (param)=>{
    let { mediaList =[]  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "product-container ".concat((_styles_components_media_media_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container)),
            children: [
                mediaList.length != 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "unfiltered honey"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "know more"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "about-honey",
                            children: "about honey"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "latest_media",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    children: "latest media"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "media_release_container",
                            children: mediaList.map((item, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "media_item",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "/media/".concat(item.attributes.Link),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: item.attributes.Title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "date",
                                                children: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__["default"])((0,date_fns__WEBPACK_IMPORTED_MODULE_5__["default"])(item.attributes.Date), "LLL d, yyyy")
                                            })
                                        ]
                                    })
                                }, "news-" + index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "natural_honey",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "title",
                            children: [
                                mediaList.length != 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "ingredients: honey"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    children: "ingredients: honey"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "desktop",
                                    children: "we test to ensure our quality"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "mobile",
                                    children: [
                                        "we test to ensure ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        " our quality"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "standards are met for"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "table",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Authenticity Analysis"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Color"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "even",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Pesticides"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Pollen and Botanical Analysis"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Antibiotics"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Moisture"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "even",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Sugar Spectrum"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Organoleptic Analysis"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
            ]
        })
    });
};


/***/ }),

/***/ 1845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/styles/components/index-about-us/index.module.scss
var index_module = __webpack_require__(5389);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(7037);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/index-about-us/index.tsx





const IndexAboutUs = ()=>{
    // these variables are used to animate the left and right image when this view are on screen.
    const ref = (0,react.useRef)(null);
    const isInView = (0,use_in_view/* useInView */.Y)(ref, {
        once: false
    });
    /**
     * this section contain html code of the about us section in which we are describing about the company.
     * and contain navigation link.
     */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "product-container ".concat((index_module_default()).about_us),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((index_module_default()).images, " ").concat(isInView ? "image_animation" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (index_module_default()).desktop,
                        src: "/assets/images/decorations/honey_gives_hope/honey_gives_hope_desktop_left.webp",
                        alt: "image",
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (index_module_default()).desktop,
                        src: "/assets/images/decorations/honey_gives_hope/honey_gives_hope_desktop_right.webp",
                        alt: "image",
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (index_module_default()).ipad,
                        src: "/assets/images/decorations/honey_gives_hope/honey_gives_hope_ipad_left.webp",
                        alt: "image",
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (index_module_default()).ipad,
                        src: "/assets/images/decorations/honey_gives_hope/honey_gives_hope_ipad_right.webp",
                        loading: "lazy",
                        alt: "image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (index_module_default()).mobile,
                        src: "/assets/images/decorations/honey_gives_hope/honey_gives_hope_mobile_left.webp",
                        loading: "lazy",
                        alt: "image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (index_module_default()).mobile,
                        src: "/assets/images/decorations/honey_gives_hope/honey_gives_hope_mobile_right.webp",
                        loading: "lazy",
                        alt: "image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).about_us_container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "titles ".concat((index_module_default()).titles),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: "title-bold ".concat((index_module_default()).title_small),
                                children: "unfiltered honey"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "title-bold ".concat((index_module_default()).title_bold),
                                children: "honey gives hope"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (index_module_default()).dotted_line
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Adopting limitless innovation to bring about plentiful supply for generations to come. The future of food security tomorrow begins with the seeds of innovation today."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/impact",
                        className: (index_module_default()).btn_learn_more,
                        children: "know more"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/styles/components/header-slider/header-slider.module.scss
var header_slider_module = __webpack_require__(316);
var header_slider_module_default = /*#__PURE__*/__webpack_require__.n(header_slider_module);
// EXTERNAL MODULE: ./node_modules/nuka-carousel/lib/carousel.js
var carousel = __webpack_require__(3162);
var carousel_default = /*#__PURE__*/__webpack_require__.n(carousel);
;// CONCATENATED MODULE: ./src/components/header-slider/HeaderSlider.tsx





// @ts-ignore
const HeaderImageSlider = (param)=>{
    let { BannerList  } = param;
    /**
     * this section contain the images' slider, used carousel for that, and some css are override to match the design.
     */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((header_slider_module_default()).header_banner),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((carousel_default()), {
            wrapAround: true,
            speed: 1000,
            cellAlign: "center",
            style: {
                overflow: "hidden"
            },
            renderCenterLeftControls: (param)=>/*#__PURE__*/ {
                let { previousDisabled , previousSlide  } = param;
                return (0,jsx_runtime.jsx)("div", {
                    className: "".concat((header_slider_module_default()).btn, " ").concat((header_slider_module_default()).btn_previous),
                    onClick: previousSlide,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/images/decorations/extra/ic_previous.svg",
                        height: 12,
                        width: 12,
                        alt: "previous"
                    })
                });
            },
            renderCenterRightControls: (param)=>/*#__PURE__*/ {
                let { nextDisabled , nextSlide  } = param;
                return (0,jsx_runtime.jsx)("div", {
                    className: "".concat((header_slider_module_default()).btn, " ").concat((header_slider_module_default()).btn_next),
                    onClick: nextSlide,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/images/decorations/extra/ic_next.svg",
                        height: 12,
                        width: 12,
                        alt: "next"
                    })
                });
            },
            renderBottomCenterControls: (param)=>/*#__PURE__*/ {
                let { slideCount , currentSlide , goToSlide  } = param;
                return (0,jsx_runtime.jsx)("div", {
                    className: (header_slider_module_default()).slider_pagination,
                    children: BannerList.map((_, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: ()=>{
                                goToSlide(index);
                            },
                            className: "".concat((header_slider_module_default()).dot, " ").concat(index == currentSlide ? (header_slider_module_default()).active : "", " ").concat(BannerList[currentSlide].attributes.IS_Dark_Image ? (header_slider_module_default()).dot_dark : "", " ").concat(index == currentSlide && BannerList[currentSlide].attributes.IS_Dark_Image ? (header_slider_module_default()).dot_dark_active : "")
                        }, "dot-" + index);
                    })
                });
            },
            children: BannerList.map((banner, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (header_slider_module_default()).slider_div,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: banner.attributes.Image.data.attributes.url,
                            width: "100%",
                            alt: banner.attributes.Image.data.attributes.alternativeText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_slider_module_default()).div_title_button,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_slider_module_default()).text_span,
                                        style: {
                                            color: banner.attributes.IS_Dark_Image ? "#F9F7F2" : "#1D1F22"
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: banner.attributes.Title
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/".concat(banner.attributes.Link),
                                        className: (header_slider_module_default()).button_span,
                                        style: {
                                            color: banner.attributes.IS_Dark_Image ? "#1D1F22" : "#F9F7F2",
                                            backgroundColor: banner.attributes.IS_Dark_Image ? "#F9F7F2" : "#1D1F22"
                                        },
                                        children: banner.attributes.Button_Title
                                    })
                                ]
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/media/media-index.tsx
var media_index = __webpack_require__(9934);
// EXTERNAL MODULE: ./src/styles/components/index-our-trust/index.module.scss
var index_our_trust_index_module = __webpack_require__(9729);
var index_our_trust_index_module_default = /*#__PURE__*/__webpack_require__.n(index_our_trust_index_module);
;// CONCATENATED MODULE: ./src/components/index-our-trust/index.tsx


const IndexOurTrust = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "product-container ".concat((index_our_trust_index_module_default()).our_trust),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "our_trust",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "unfiltered honey"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "desktop",
                        children: "purity guarantee"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "ipad-mobile",
                        children: "purity guarantee"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "We put care into crafting raw honey with award-winning flavor. That’s why our strict testing standards ensure our honey is unfiltered as it is straight from the hive. This is our purity guarantee: to provide an unmatched level of care and precision that any honeybee would be proud of."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "right_side",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/images/decorations/index/process_section_illustration.webp",
                        alt: "sidr process"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx







// Loading Component Client Side
const HoneyListSlider = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8224).then(__webpack_require__.bind(__webpack_require__, 8224)).then((mod)=>mod.HoneyListSlider), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8224)
            ]
    }
});
// @ts-ignore
function Index(param) {
    let { BannerList , Collections , mediaList  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageSlider, {
                BannerList: BannerList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "our-products",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "sidr raw & unfiltered honey, 100% pure."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Through our comprehensive industry-leading standards for honey quality and authenticity and third-party testing measures, we can ensure the high-quality, unadulterated, raw & unfiltered honey ends up in your jar."
                    })
                ]
            }),
            Collections.map((collection, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoneyListSlider, {
                            Collection: collection,
                            index: index
                        }, "honey-" + index),
                        index == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexOurTrust, {}, "honey-" + index)
                    ]
                });
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(media_index/* IndexMedia */.T, {
                mediaList: mediaList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexAboutUs, {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ 316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","header_banner":"header-slider_header_banner__EB0s1","slider_div":"header-slider_slider_div__En3qZ","div_title_button":"header-slider_div_title_button__ftOW4","text_span":"header-slider_text_span__TVRsD","button_span":"header-slider_button_span__33l4p","slider_pagination":"header-slider_slider_pagination__l5a_l","dot":"header-slider_dot__kBP_B","active":"header-slider_active__V4Lyh","dot_dark":"header-slider_dot_dark__upk3r","dot_dark_active":"header-slider_dot_dark_active__xA_PZ","slider_body":"header-slider_slider_body__4F1m2","slider":"header-slider_slider__JDs_E","slide":"header-slider_slide__gYJek","active_image":"header-slider_active_image__OT5tJ","btn":"header-slider_btn__MvPL2","btn_previous":"header-slider_btn_previous__q7O4P","btn_next":"header-slider_btn_next___b7Np","about-image-in":"header-slider_about-image-in__hevz_","fade-in-honeycomb":"header-slider_fade-in-honeycomb__kvtab","dot-falling":"header-slider_dot-falling__AvgOf","dot-falling-before":"header-slider_dot-falling-before__0kmpM","dot-falling-after":"header-slider_dot-falling-after__UMy_9"};

/***/ }),

/***/ 5389:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","about_us":"index-about-us_about_us__In2RM","about_us_container":"index-about-us_about_us_container__VLdg6","titles":"index-about-us_titles__SoHh_","title_bold":"index-about-us_title_bold__du8id","title_small":"index-about-us_title_small__OQwJC","dotted_line":"index-about-us_dotted_line__RkgX8","btn_learn_more":"index-about-us_btn_learn_more__cZxeJ","images":"index-about-us_images__aoAIk","desktop":"index-about-us_desktop__ZTCk1","ipad":"index-about-us_ipad__vQBWr","mobile":"index-about-us_mobile__0vgIs","about-image-in":"index-about-us_about-image-in__kPemN","fade-in-honeycomb":"index-about-us_fade-in-honeycomb__wyWlX","dot-falling":"index-about-us_dot-falling__KJ9Ds","dot-falling-before":"index-about-us_dot-falling-before__9IazT","dot-falling-after":"index-about-us_dot-falling-after__v4FHP"};

/***/ }),

/***/ 9729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","our_trust":"index-our-trust_our_trust__GzC_5","about-image-in":"index-our-trust_about-image-in__S5hED","fade-in-honeycomb":"index-our-trust_fade-in-honeycomb__R3kl0","dot-falling":"index-our-trust_dot-falling__QwN8o","dot-falling-before":"index-our-trust_dot-falling-before__7qy63","dot-falling-after":"index-our-trust_dot-falling-after__Gk__t"};

/***/ }),

/***/ 4236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","container":"media_container__XhmOe","about-image-in":"media_about-image-in__6TL_8","fade-in-honeycomb":"media_fade-in-honeycomb___O2qg","dot-falling":"media_dot-falling__BfAk9","dot-falling-before":"media_dot-falling-before__tzJ9J","dot-falling-after":"media_dot-falling-after__xWeWi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1074,9934,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);